import React from 'react'
import s from './description.scss'

interface DescriptionProps {
  event: wix.events.Event
}

export const Description = ({event}: DescriptionProps) => {
  if (!event.description) {
    return null
  }

  return (
    <div className={s.description} data-hook="ev-list-item-description">
      {event.description}
    </div>
  )
}
